import { useQuery } from "@tanstack/react-query"
import { apiClient } from "../helpers/Axios"

export const useLocations = () => {
    return useQuery({
        queryKey: ['our-shop'],
        queryFn: async () => {
            const res = await apiClient.get('/shop/locations');
            return res.data;
        }
    })
}